import { Image, FileSignature, Target, Bot, Globe, FileText, AlertTriangle } from "lucide-react";

const RISKS = [
  { id: "imagenes", icon: Image, color: "red", title: "Uso de imágenes y datos sensibles", desc: "Revisamos si se están utilizando fotografías, vídeos o datos de salud en herramientas de IA sin las garantías legales adecuadas bajo el RGPD y la normativa sanitaria." },
  { id: "consentimiento", icon: FileSignature, color: "orange", title: "Consentimiento insuficiente", desc: "Analizamos si el paciente conoce que se emplea IA, qué alcance tiene y qué advertencias deben incluirse en simulaciones, recomendaciones o diagnósticos asistidos." },
  { id: "marketing", icon: Target, color: "yellow", title: "Marketing automatizado con riesgo", desc: "Detectamos mensajes, flujos automatizados y chatbots que pueden generar expectativas inadecuadas, incumplir la normativa de publicidad sanitaria o crear problemas de transparencia." },
  { id: "supervision", icon: Bot, color: "purple", title: "IA sin supervisión humana", desc: "Identificamos procesos donde la IA toma o influye decisiones sobre pacientes sin la revisión profesional exigida por la normativa sanitaria y el AI Act europeo." },
  { id: "transferencias", icon: Globe, color: "cyan", title: "Transferencias internacionales de datos", desc: "Detectamos herramientas que procesan datos fuera de la UE sin garantías adecuadas, una de las infracciones más habituales y menos controladas en clínicas." },
  { id: "gobernanza", icon: FileText, color: "blue", title: "Ausencia de gobernanza interna", desc: "Evaluamos si la clínica cuenta con políticas claras de uso de IA, protocolos de validación y formación al equipo para un uso responsable y documentado." },
];

export function ProblemsSection() {
  return (
    <section id="problemas" className="section-dark" data-testid="problems-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="eyebrow mb-4 inline-flex">
            <AlertTriangle className="w-4 h-4" />
            <span>Riesgos frecuentes</span>
          </span>
          <h2 className="section-title mt-4">Qué problemas resolvemos</h2>
          <p className="section-subtitle mx-auto mt-4">
            Muchas clínicas ya usan IA en marketing, simulación, captación o análisis de imagen sin tener completamente controladas sus implicaciones legales y organizativas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {RISKS.map((item) => (
            <div key={item.id} className="risk-card" data-testid={`risk-card-${item.id}`}>
              <div className={`benefit-icon ${item.color} mb-4`}>
                <item.icon className="w-5 h-5" />
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 rounded-xl border border-gray-700 bg-gray-800/30">
          <h4 className="text-white font-semibold mb-2">Marco legal aplicable en España</h4>
          <p className="text-gray-400 text-sm leading-relaxed">
            El uso de IA en clínicas estéticas está sujeto a múltiples normas concurrentes: el <strong className="text-white">Reglamento (UE) 2016/679 (RGPD)</strong>, la <strong className="text-white">LOPDGDD</strong>, el <strong className="text-white">Reglamento europeo de IA (AI Act, Reglamento UE 2024/1689)</strong>, la <strong className="text-white">Ley 41/2002 de autonomía del paciente</strong> y la normativa específica de publicidad sanitaria. Ignorar alguna de estas capas puede generar sanciones significativas o reclamaciones de pacientes.
          </p>
        </div>
      </div>
    </section>
  );
}
